import { Dropdown } from "@/src/component/base/Dropdown";
import { ENV } from "@/src/const";
import router, { useRouter } from "next/router";

const toolkitOptionsDev = [
  { value: "dev.notflow.life", label: "dev.notflow.life" },
  { value: "dev.flowhouse.life", label: "dev.flowhouse.life" },
  { value: "dev.flowhotel.life", label: "dev.flowhotel.life" },
  { value: "dev.rentflowhouse.life", label: "dev.rentflowhouse.life" },
  { value: "dev.flowfarmersmarket.life", label: "dev.flowfarmersmarket.life" },
];

const toolkitOptionsProd = [
  { value: "flowhouse.life", label: "flowhouse.life" },
  { value: "flowfarmersmarket.life", label: "flowfarmersmarket.life" },
  { value: "flowhotel.life", label: "flowhotel.life" },
  { value: "flow.life", label: "flow.life" },
  { value: "rentflowhouse.life", label: "rentflowhouse.life" },
];

const options = ENV === "prod" ? toolkitOptionsProd : toolkitOptionsDev;

function ToolkitSelector() {
  const { query } = useRouter();

  return (
    <Dropdown
      options={options}
      value={query.toolkitDomain as string}
      onChange={(e) => {
        router.push(`/c/en/home?toolkitDomain=${e.target.value}`);
      }}
      label="Select a domain"
      id={"toolkit-selector"}
    />
  );
}

export default ToolkitSelector;
